/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__focus_navigation__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__focus_navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__focus_navigation__);


$(function () {
    var $mapLinks = $('.map__link');
    var $languageModal = $('#languageModal');

    // map
    function toggleInfo(event) {
        var $mapLink = $(this);
        var state = $(this).children(0).get(0).id;
        var $info = $('#' + state + '-text');

        // turn off all other states
        if (['mouseenter', 'focus'].indexOf(event.type) > -1) {
            $info.addClass('in');
            $info.attr('aria-hidden', 'false');
            $mapLink.attr('aria-expanded', 'true');
        }

        if (['mouseleave', 'blur'].indexOf(event.type) > -1) {
            $info.removeClass('in');
            $info.attr('aria-hidden', 'true');
            $mapLink.attr('aria-expanded', 'false');
        }
    }

    $mapLinks.mouseleave(toggleInfo);
    $mapLinks.mouseenter(toggleInfo);
    $mapLinks.focus(toggleInfo);
    $mapLinks.blur(toggleInfo);
});

var modal = document.querySelector('.modal')

window.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
        //modal.style.display = 'none'
        $('.modal:not(.cookie-consent, .cookie-setting)').modal('hide');
    }
})

/*
document.addEventListener('DOMContentLoaded', function () {
    const teaser = document.querySelector('.teaser');
    const checkbox = teaser.querySelector('.form-check-input');
    const select = teaser.querySelector('.form-select');
    const button = teaser.querySelector('.btn--primary');

    if (!checkbox || !select || !button) return;

    function updateButtonState() {
        button.disabled = !(checkbox.checked && select.value !== '');
    }

    // Initialen Zustand setzen
    updateButtonState();

    checkbox.addEventListener('change', updateButtonState);
    select.addEventListener('change', updateButtonState);
});
 */


/***/ }),
/* 1 */
/***/ (function(module, exports) {

function handleTrapEvent(lastFocusableElement, firstFocusableElement) {
	return function eventHandler(event) {
		var isTabPressed = event.key === 'Tab' || event.keyCode === 9;

		if (!isTabPressed) {
			return;
		}

		if (event.shiftKey) {
			if (document.activeElement === firstFocusableElement) {
				lastFocusableElement.focus();
				event.preventDefault();
			}
		} else if (document.activeElement === lastFocusableElement) {
			firstFocusableElement.focus();
			event.preventDefault();
		}
	};
}

function addTrapHandler(modal) {
	var focusableElements = Array.prototype.slice.call(
		modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
	).filter(function (el) {
		return !el.closest('[inert="inert"]');
	});
	var firstFocusableElement = focusableElements[0];
	var lastFocusableElement = focusableElements[focusableElements.length - 1];
	document.addEventListener('keydown', handleTrapEvent(lastFocusableElement, firstFocusableElement));
}

function triggerInert() {
	var quickLink = document.querySelector('.navigation-main__quick-links');
	var setInert = function () {
		if (window.innerWidth >= 979) {
			quickLink.setAttribute('inert', 'inert');
		} else {
			quickLink.removeAttribute('inert');
		}
	};
	setInert(); // Apply on load
	window.addEventListener('resize', setInert); // Apply on resize
}

document.addEventListener('DOMContentLoaded', function () {
	triggerInert();
	Array.prototype.forEach.call(document.querySelectorAll('.modal'), addTrapHandler);
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// script.min.js